import type { UI } from '@/v2/types';

import createRoomOptionCTA from '@shared/v2/components/createRoomOptionCTA';
import { CtaEvent } from '@shared/v2/components/createRoomOptionCTA/types';

import { usePackagePageV3 } from '@/v2/hooks/featureFlags/packagePageV3/usePackagePageV3';
import { useRoomOptionsData } from '../../../../../../contexts/RoomOptionsContext';
import OfferPrice from '../../../../../OfferPrice';
import CTAButton from './components/CTAButton';
import EnterDatesForPricing from './components/EnterDatesForPricing';
import LeadInOfferPrice from './components/LeadInOfferPrice';
import Unavailable from './components/Unavailable';

export type CTAProps = {
  roomOption: UI.RoomOption;
  isSelected: boolean;
  onClick: (event: CtaEvent, opts: { ctaText: string }) => void;
  isMainRooms?: boolean;
};

const RoomOptionCTA = createRoomOptionCTA({
  CTAButton,
  LeadInOfferPrice,
  Unavailable,
  EnterDatesForPricing,
  OfferPrice,
  usePackagePageV3,
});

const CTA = ({ roomOption, isSelected, onClick, isMainRooms }: CTAProps) => {
  const {
    isPreSearch,
    isBestRates,
    isOriginSelected,
    isPackageSelected,
    route,
    travellerCount,
  } = useRoomOptionsData() || {};

  return (
    <RoomOptionCTA
      roomOption={roomOption}
      isPreSearch={isPreSearch}
      isBestRates={isBestRates}
      isOriginAndPackageSelected={isOriginSelected && isPackageSelected}
      route={route}
      onCtaClick={onClick}
      isSelected={isSelected}
      travellerCount={travellerCount}
      isMainRooms={isMainRooms}
    />
  );
};

export default CTA;
